/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type EditScheduleModal_ScheduleFragment = { __typename: 'Schedule', id: string, title: string, description: string };

export type ScheduleEditMutationVariables = Types.Exact<{
  input: Types.ScheduleUpdateInput;
}>;


export type ScheduleEditMutation = { __typename: 'Mutation', scheduleUpdate: { __typename: 'ScheduleUpdatePayload', schedule: { __typename: 'Schedule', id: string, title: string, description: string } } };

export const EditScheduleModal_ScheduleFragmentDoc = gql`
    fragment EditScheduleModal_schedule on Schedule {
  id
  title
  description
}
    `;
export const ScheduleEditDocument = gql`
    mutation ScheduleEdit($input: ScheduleUpdateInput!) {
  scheduleUpdate(input: $input) {
    schedule {
      id
      ...EditScheduleModal_schedule
    }
  }
}
    ${EditScheduleModal_ScheduleFragmentDoc}`;
export type ScheduleEditMutationFn = ApolloReactCommon.MutationFunction<ScheduleEditMutation, ScheduleEditMutationVariables>;

/**
 * __useScheduleEditMutation__
 *
 * To run a mutation, you first call `useScheduleEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleEditMutation, { data, loading, error }] = useScheduleEditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleEditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleEditMutation, ScheduleEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ScheduleEditMutation, ScheduleEditMutationVariables>(ScheduleEditDocument, options);
      }
export type ScheduleEditMutationHookResult = ReturnType<typeof useScheduleEditMutation>;
export type ScheduleEditMutationResult = ApolloReactCommon.MutationResult<ScheduleEditMutation>;
export type ScheduleEditMutationOptions = ApolloReactCommon.BaseMutationOptions<ScheduleEditMutation, ScheduleEditMutationVariables>;